<template>
    <UBadge :color="meta.color" :label="meta.label" variant="subtle" />
</template>

<script setup lang="ts">
import { CONDITION_META, type EquipmentCondition } from '~/types/fieldPost'

const props = defineProps<{
    condition: EquipmentCondition
}>()

const meta = computed(() => CONDITION_META[props.condition])
</script>
